var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-4"},[_c('v-toolbar',[_c('v-toolbar-title',[_vm._v("SERVE Student Portal")])],1),_c('v-card-text',[(_vm.id)?_c('serve-detail',{attrs:{"id":_vm.id}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }